// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const BackArrowLight = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.875 10c0 5.454-4.421 9.875-9.875 9.875S.125 15.454.125 10 4.546.125 10 .125 19.875 4.546 19.875 10ZM13 15.024c0-.363-.17-.68-.432-.904L8.34 10.115l4.163-3.945c.295-.223.496-.555.496-.943C13 4.55 12.425 4 11.714 4c-.356 0-.677.14-.91.362l-5.187 4.92c-.225.22-.367.514-.367.843 0 .324.14.614.358.832l5.188 4.92c.233.228.557.373.918.373.711 0 1.286-.549 1.286-1.226Z"
			fill="#fff"
		/>
	</svg>
);
export default BackArrowLight;
